import React from 'react';
import ReactDOM from 'react-dom';
import Clock from './clock';
import AddName from './addname'
import registerServiceWorker from './registerServiceWorker';
import './App.css';


class App extends React.Component {

  static defaultProps = {
    categories: ["Normal","Energized", "Tired", "Hungry", "Busy", "Struggling", "Pissed Off", "Dead"]
  };

  handleSubmit(e) {
    var f = document.getElementById("dropdown");
    var name = document.getElementsByClassName("name");
    var div = document.getElementById("results")
    var text = f.options[f.selectedIndex].text;
    var para = document.createElement("p");
    var textNode = document.createTextNode(name[0].value + " is " + text + " at " + new Date().toLocaleTimeString());
    para.appendChild(textNode)
    if(name[0].value === ""){
      alert("Please enter your name")
    } else {
      div.appendChild(para)
    };
    name[0].value = "";
    e.preventDefault();
  }

  clearList(e){
    var f = document.getElementById("dropdown");
    var div = document.getElementById("results");
    var text = f.options[f.selectedIndex].text;
    var textNode = document.createTextNode(text);
    div.innerHTML = "";
    e.preventDefault();
  }
  render() {
    let categoriesOption = this.props.categories.map(category => {
      return <option key={category} value="category">{category}</option>
    })

  return (
     <div className = "app">
      <h1>
        React Work Mood App
      </h1>
      <h3>Built by {this.props.name}</h3>
      <Clock />
      <AddName />
      <form id="form" onSubmit={this.handleSubmit.bind(this)}>
        <select id="dropdown">
          {categoriesOption}
        </select><br />
        <input id="submit" type="submit" value="Submit"/>
        <button onClick={this.clearList.bind(this)}>Clear</button>
      </form>

      <div id="results">
      </div>
     </div>
    );
  }
}

const myApp = <App name="Adam"/>;
const root = document.getElementById('root');

ReactDOM.render(myApp, root);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js